// Generated by purs version 0.15.16
import * as API_Comments from "../API.Comments/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Record from "../Record/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Widgets_Form_Access from "../Widgets.Form.Access/index.js";
var map = /* #__PURE__ */ Data_Functor.map(GraphQL_Query.queryFunctor);
var rltvCons = /* #__PURE__ */ GraphQL_Query.rltvCons(GraphQL_Query.rltvNil);
var inputIsSymbol = {
    reflectSymbol: function () {
        return "input";
    }
};
var rltvCons1 = /* #__PURE__ */ rltvCons(inputIsSymbol);
var encRNTY = /* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encRNTY);
var form_idIsSymbol = {
    reflectSymbol: function () {
        return "form_id";
    }
};
var rltvfConsOther = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(GraphQL_Query.rltvfNil);
var rltvfConsOther1 = /* #__PURE__ */ rltvfConsOther(inputIsSymbol)();
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Widgets_Form_Access.decodeFieldAccessLevel));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons2 = /* #__PURE__ */ gDecodeJsonCons1(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var fieldIsSymbol = {
    reflectSymbol: function () {
        return "field";
    }
};
var accessIsSymbol = {
    reflectSymbol: function () {
        return "access";
    }
};
var fieldsIsSymbol = {
    reflectSymbol: function () {
        return "fields";
    }
};
var defaultIsSymbol = {
    reflectSymbol: function () {
        return "default";
    }
};
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons2(fieldIsSymbol)()())(accessIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(fieldsIsSymbol)()())(defaultIsSymbol)()())()));
var gDecodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean));
var gDecodeJsonCons5 = /* #__PURE__ */ gDecodeJsonCons4(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var updateIsSymbol = {
    reflectSymbol: function () {
        return "update";
    }
};
var gDecodeJsonCons6 = /* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons5(updateIsSymbol)()());
var lockIsSymbol = {
    reflectSymbol: function () {
        return "lock";
    }
};
var gDecodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)));
var gDecodeJsonCons8 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Internal_Luxon.decodeLDT));
var useDefaultIsSymbol = {
    reflectSymbol: function () {
        return "useDefault";
    }
};
var saveDefaultIsSymbol = {
    reflectSymbol: function () {
        return "saveDefault";
    }
};
var requestIsSymbol = {
    reflectSymbol: function () {
        return "request";
    }
};
var createIsSymbol = {
    reflectSymbol: function () {
        return "create";
    }
};
var gDecodeJsonCons9 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons10 = /* #__PURE__ */ gDecodeJsonCons7(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var relationshipIsSymbol = {
    reflectSymbol: function () {
        return "relationship";
    }
};
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var emailLabelIsSymbol = {
    reflectSymbol: function () {
        return "emailLabel";
    }
};
var default_last_nameIsSymbol = {
    reflectSymbol: function () {
        return "default_last_name";
    }
};
var default_first_nameIsSymbol = {
    reflectSymbol: function () {
        return "default_first_name";
    }
};
var default_emailIsSymbol = {
    reflectSymbol: function () {
        return "default_email";
    }
};
var canIsSymbol = {
    reflectSymbol: function () {
        return "can";
    }
};
var gDecodeJsonCons11 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons5(useDefaultIsSymbol)()())(updateIsSymbol)()())(saveDefaultIsSymbol)()())(requestIsSymbol)()())(createIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons10(relationshipIsSymbol)()())(labelIsSymbol)()())(keyIsSymbol)()())(emailLabelIsSymbol)()())(default_last_nameIsSymbol)()())(default_first_nameIsSymbol)()())(default_emailIsSymbol)()())(canIsSymbol)()())())));
var last_nameIsSymbol = {
    reflectSymbol: function () {
        return "last_name";
    }
};
var first_nameIsSymbol = {
    reflectSymbol: function () {
        return "first_name";
    }
};
var emailIsSymbol = {
    reflectSymbol: function () {
        return "email";
    }
};
var gDecodeJsonCons12 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Internal_Luxon.decodeLDT));
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var gDecodeJsonCons13 = /* #__PURE__ */ gDecodeJsonCons2(urlIsSymbol)()();
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var created_atIsSymbol = {
    reflectSymbol: function () {
        return "created_at";
    }
};
var contactIsSymbol = {
    reflectSymbol: function () {
        return "contact";
    }
};
var gDecodeJsonCons14 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(last_nameIsSymbol)()())(first_nameIsSymbol)()())(emailIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons12(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons7(gDecodeJsonCons13)(relationshipIsSymbol)()())(keyIsSymbol)()())(idIsSymbol)()())(created_atIsSymbol)()())(contactIsSymbol)()())())));
var commentIsSymbol = {
    reflectSymbol: function () {
        return "comment";
    }
};
var linkIsSymbol = {
    reflectSymbol: function () {
        return "link";
    }
};
var dataIsSymbol = {
    reflectSymbol: function () {
        return "data";
    }
};
var verificationsIsSymbol = {
    reflectSymbol: function () {
        return "verifications";
    }
};
var gDecodeJsonCons15 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons12(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons10(keyIsSymbol)()())(emailIsSymbol)()())(commentIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons2(linkIsSymbol)()())(idIsSymbol)()())(dataIsSymbol)()())(created_atIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(verificationsIsSymbol)()();
var signaturesIsSymbol = {
    reflectSymbol: function () {
        return "signatures";
    }
};
var signature_fieldsIsSymbol = {
    reflectSymbol: function () {
        return "signature_fields";
    }
};
var locked_atIsSymbol = {
    reflectSymbol: function () {
        return "locked_at";
    }
};
var formsIsSymbol = {
    reflectSymbol: function () {
        return "forms";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var rlhsCons1 = /* #__PURE__ */ rlhsCons(formsIsSymbol);
var maybeShape = /* #__PURE__ */ GraphQL_Shape.maybeShape(GraphQL_Shape.scalarShape);
var rlhsCons2 = /* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(verificationsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(linkIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(dataIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(keyIsSymbol)(GraphQL_Shape.scalarShape)()())(emailIsSymbol)(GraphQL_Shape.scalarShape)()())(commentIsSymbol)(maybeShape)()())())()())(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())()))()());
var rlhsCons3 = /* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(urlIsSymbol)(GraphQL_Shape.scalarShape)()());
var arrayShape = /* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons3(relationshipIsSymbol)(GraphQL_Shape.scalarShape)()())(keyIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())(contactIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(last_nameIsSymbol)(GraphQL_Shape.scalarShape)()())(first_nameIsSymbol)(GraphQL_Shape.scalarShape)()())(emailIsSymbol)(GraphQL_Shape.scalarShape)()())())()())());
var arrayShape1 = /* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(relationshipIsSymbol)(GraphQL_Shape.scalarShape)()())(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(keyIsSymbol)(GraphQL_Shape.scalarShape)()())(emailLabelIsSymbol)(GraphQL_Shape.scalarShape)()())(default_last_nameIsSymbol)(maybeShape)()())(default_first_nameIsSymbol)(maybeShape)()())(default_emailIsSymbol)(maybeShape)()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(useDefaultIsSymbol)(GraphQL_Shape.scalarShape)()())(updateIsSymbol)(GraphQL_Shape.scalarShape)()())(saveDefaultIsSymbol)(GraphQL_Shape.scalarShape)()())(requestIsSymbol)(GraphQL_Shape.scalarShape)()())(createIsSymbol)(GraphQL_Shape.scalarShape)()())())()())());
var rlhsCons4 = /* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(updateIsSymbol)(GraphQL_Shape.scalarShape)()());
var recShape = /* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(fieldsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(fieldIsSymbol)(GraphQL_Shape.scalarShape)()())(accessIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(defaultIsSymbol)(GraphQL_Shape.scalarShape)()())();
var buildMutation = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons1(/* #__PURE__ */ GraphQL_Type.hqtArray(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "UpdateFormInput";
    }
})))(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "locked";
    }
})())(form_idIsSymbol)())())))()())(rltvfConsOther1)())(/* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons6(lockIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons11(/* #__PURE__ */ gDecodeJsonCons14(gDecodeJsonCons15)(signaturesIsSymbol)()())(signature_fieldsIsSymbol)()())(locked_atIsSymbol)()())(idIsSymbol)()())(canIsSymbol)()())(accessIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(formsIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons1(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons2(signaturesIsSymbol)(arrayShape)()())(signature_fieldsIsSymbol)(arrayShape1)()())(locked_atIsSymbol)(maybeShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons4(lockIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(accessIsSymbol)(recShape)()())()))()())()));
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var merge = /* #__PURE__ */ Record.merge()();
var typeIsSymbol = {
    reflectSymbol: function () {
        return "type";
    }
};
var rename = /* #__PURE__ */ Record.rename(typeIsSymbol)({
    reflectSymbol: function () {
        return "formName";
    }
})()()()();
var rename1 = /* #__PURE__ */ Record.rename(dataIsSymbol)({
    reflectSymbol: function () {
        return "json";
    }
})()()()();
var commentsIsSymbol = {
    reflectSymbol: function () {
        return "comments";
    }
};
var modify = /* #__PURE__ */ Record.modify(commentsIsSymbol)()();
var teacher_idIsSymbol = {
    reflectSymbol: function () {
        return "teacher_id";
    }
};
var rltvCons2 = /* #__PURE__ */ rltvCons(teacher_idIsSymbol);
var rntyType = /* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "ID";
    }
});
var semesterIsSymbol = {
    reflectSymbol: function () {
        return "semester";
    }
};
var rltvfConsOther2 = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ rltvfConsOther(teacher_idIsSymbol)());
var deleteIsSymbol = {
    reflectSymbol: function () {
        return "delete";
    }
};
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var gDecodeJsonCons16 = /* #__PURE__ */ gDecodeJsonCons2(nameIsSymbol)()();
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons16)();
var userIsSymbol = {
    reflectSymbol: function () {
        return "user";
    }
};
var pathIsSymbol = {
    reflectSymbol: function () {
        return "path";
    }
};
var descriptionIsSymbol = {
    reflectSymbol: function () {
        return "description";
    }
};
var private_commentIsSymbol = {
    reflectSymbol: function () {
        return "private_comment";
    }
};
var create_employersIsSymbol = {
    reflectSymbol: function () {
        return "create_employers";
    }
};
var copyIsSymbol = {
    reflectSymbol: function () {
        return "copy";
    }
};
var attachIsSymbol = {
    reflectSymbol: function () {
        return "attach";
    }
};
var TeacherIsSymbol = {
    reflectSymbol: function () {
        return "Teacher";
    }
};
var StudentIsSymbol = {
    reflectSymbol: function () {
        return "Student";
    }
};
var updated_atIsSymbol = {
    reflectSymbol: function () {
        return "updated_at";
    }
};
var publicIsSymbol = {
    reflectSymbol: function () {
        return "public";
    }
};
var authorIsSymbol = {
    reflectSymbol: function () {
        return "author";
    }
};
var decodeRecord1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons7(gDecodeJsonCons16)(idIsSymbol)()())();
var gDecodeJsonCons17 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(decodeRecord1));
var gDecodeJsonCons18 = /* #__PURE__ */ gDecodeJsonCons1(gDecodeJsonCons16);
var decodeRecord2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons2(labelIsSymbol)()())(idIsSymbol)()())();
var positionsIsSymbol = {
    reflectSymbol: function () {
        return "positions";
    }
};
var deleted_atIsSymbol = {
    reflectSymbol: function () {
        return "deleted_at";
    }
};
var contactsIsSymbol = {
    reflectSymbol: function () {
        return "contacts";
    }
};
var companyIsSymbol = {
    reflectSymbol: function () {
        return "company";
    }
};
var formatIsSymbol = {
    reflectSymbol: function () {
        return "format";
    }
};
var gDecodeJsonCons19 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(gDecodeJsonCons13)(labelIsSymbol)()())(formatIsSymbol)()())())));
var colorIsSymbol = {
    reflectSymbol: function () {
        return "color";
    }
};
var tagsIsSymbol = {
    reflectSymbol: function () {
        return "tags";
    }
};
var preferred_nameIsSymbol = {
    reflectSymbol: function () {
        return "preferred_name";
    }
};
var last_imported_atIsSymbol = {
    reflectSymbol: function () {
        return "last_imported_at";
    }
};
var teacherIsSymbol = {
    reflectSymbol: function () {
        return "teacher";
    }
};
var studentIsSymbol = {
    reflectSymbol: function () {
        return "student";
    }
};
var positionIsSymbol = {
    reflectSymbol: function () {
        return "position";
    }
};
var exportsIsSymbol = {
    reflectSymbol: function () {
        return "exports";
    }
};
var employerIsSymbol = {
    reflectSymbol: function () {
        return "employer";
    }
};
var coursesIsSymbol = {
    reflectSymbol: function () {
        return "courses";
    }
};
var attachmentsIsSymbol = {
    reflectSymbol: function () {
        return "attachments";
    }
};
var rlhsCons5 = /* #__PURE__ */ rlhsCons(nameIsSymbol)(GraphQL_Shape.scalarShape)()();
var rlhsCons6 = /* #__PURE__ */ GraphQL_Shape.rlhsCons(rlhsCons5);
var recShape1 = /* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons6(idIsSymbol)(GraphQL_Shape.scalarShape)()())();
var maybeShape1 = /* #__PURE__ */ GraphQL_Shape.maybeShape(recShape1);
var recShape2 = /* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())();
var arrayShape2 = /* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons3(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(formatIsSymbol)(GraphQL_Shape.scalarShape)()())());
var recShape3 = /* #__PURE__ */ GraphQL_Shape.recShape(rlhsCons5)();
var jsonQR = /* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons5(deleteIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons12(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeRecord))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(userIsSymbol)()())(urlIsSymbol)()())(pathIsSymbol)()())(idIsSymbol)()())(descriptionIsSymbol)()())(created_atIsSymbol)()())(canIsSymbol)()())())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons6(private_commentIsSymbol)()())(lockIsSymbol)()())(deleteIsSymbol)()())(create_employersIsSymbol)()())(copyIsSymbol)()())(commentIsSymbol)()())(attachIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Shape.unionDecode(/* #__PURE__ */ GraphQL_Shape.unDecCons(/* #__PURE__ */ GraphQL_Shape.unDecCons(GraphQL_Shape.unDecNil)(TeacherIsSymbol)(decodeRecord)()())(StudentIsSymbol)(decodeRecord)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons6(deleteIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons12(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons12(Data_Argonaut_Decode_Class.gDecodeJsonNil)(updated_atIsSymbol)()())(publicIsSymbol)()())(idIsSymbol)()())(created_atIsSymbol)()())(commentIsSymbol)()())(canIsSymbol)()())(authorIsSymbol)()())())))(/* #__PURE__ */ gDecodeJsonCons17(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons18(labelIsSymbol)()())(idIsSymbol)()())())))(/* #__PURE__ */ gDecodeJsonCons12(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonJson))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(decodeRecord1)))(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(decodeRecord2)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(positionsIsSymbol)()())(idIsSymbol)()())(deleted_atIsSymbol)()())(contactsIsSymbol)()())(companyIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons19(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(decodeRecord2))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(semesterIsSymbol)()())(nameIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons11(/* #__PURE__ */ gDecodeJsonCons14(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons18(colorIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(tagsIsSymbol)()())(preferred_nameIsSymbol)()())(nameIsSymbol)()())(last_imported_atIsSymbol)()())(idIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons17(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons12(gDecodeJsonCons15)(updated_atIsSymbol)()())(typeIsSymbol)()())(teacherIsSymbol)()())(studentIsSymbol)()())(signaturesIsSymbol)()())(signature_fieldsIsSymbol)()())(semesterIsSymbol)()())(positionIsSymbol)()())(locked_atIsSymbol)()())(idIsSymbol)()())(exportsIsSymbol)()())(employerIsSymbol)()())(dataIsSymbol)()())(created_atIsSymbol)()())(coursesIsSymbol)()())(contactIsSymbol)()())(commentsIsSymbol)()())(canIsSymbol)()())(attachmentsIsSymbol)()())(accessIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons2(updated_atIsSymbol)(GraphQL_Shape.scalarShape)()())(typeIsSymbol)(GraphQL_Shape.scalarShape)()())(teacherIsSymbol)(maybeShape1)()())(studentIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(tagsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons6(colorIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(preferred_nameIsSymbol)(maybeShape)()())(nameIsSymbol)(GraphQL_Shape.scalarShape)()())(last_imported_atIsSymbol)(maybeShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(signaturesIsSymbol)(arrayShape)()())(signature_fieldsIsSymbol)(arrayShape1)()())(semesterIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(semesterIsSymbol)(GraphQL_Shape.scalarShape)()())(nameIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(positionIsSymbol)(/* #__PURE__ */ GraphQL_Shape.maybeShape(recShape2))()())(locked_atIsSymbol)(maybeShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(exportsIsSymbol)(arrayShape2)()())(employerIsSymbol)(/* #__PURE__ */ GraphQL_Shape.maybeShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(positionsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(recShape2))()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(deleted_atIsSymbol)(maybeShape)()())(contactsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(recShape1))()())(companyIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(dataIsSymbol)(GraphQL_Shape.scalarShape)()())(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())(coursesIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons6(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(contactIsSymbol)(maybeShape1)()())(commentsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(updated_atIsSymbol)(GraphQL_Shape.scalarShape)()())(publicIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())(commentIsSymbol)(GraphQL_Shape.scalarShape)()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons4(deleteIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(authorIsSymbol)(/* #__PURE__ */ GraphQL_Shape.unionShape(/* #__PURE__ */ GraphQL_Shape.varhsCons(/* #__PURE__ */ GraphQL_Shape.varhsCons(GraphQL_Shape.varhsNil)(TeacherIsSymbol)(recShape3)()())(StudentIsSymbol)(recShape3)()())())()())()))()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons4(private_commentIsSymbol)(GraphQL_Shape.scalarShape)()())(lockIsSymbol)(GraphQL_Shape.scalarShape)()())(deleteIsSymbol)(GraphQL_Shape.scalarShape)()())(create_employersIsSymbol)(GraphQL_Shape.scalarShape)()())(copyIsSymbol)(GraphQL_Shape.scalarShape)()())(commentIsSymbol)(GraphQL_Shape.scalarShape)()())(attachIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(attachmentsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(userIsSymbol)(recShape3)()())(urlIsSymbol)(GraphQL_Shape.scalarShape)()())(pathIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(descriptionIsSymbol)(GraphQL_Shape.scalarShape)()())(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(deleteIsSymbol)(GraphQL_Shape.scalarShape)()())())()())()))()())(accessIsSymbol)(recShape)()())());
var buildMutation1 = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvDyTyCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ rltvCons2(rntyType)(encRNTY)()())(semesterIsSymbol)(GraphQL_Type.hqtStr)(Data_Argonaut_Encode_Class.encodeJsonJString)()())(idIsSymbol)(rntyType)(encRNTY)()())(dataIsSymbol)(Data_Argonaut_Encode_Class.encodeJsonJson)()())(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ rltvfConsOther2(semesterIsSymbol)())(idIsSymbol)())(dataIsSymbol)())())(jsonQR);
var buildQuery = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(idIsSymbol)(rntyType)(encRNTY)()())(/* #__PURE__ */ rltvfConsOther(idIsSymbol)())())(jsonQR);
var idsIsSymbol = {
    reflectSymbol: function () {
        return "ids";
    }
};
var hqtArray = /* #__PURE__ */ GraphQL_Type.hqtArray(rntyType);
var encodeJsonArray = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encRNTY);
var jsonQR1 = /* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons19(Data_Argonaut_Decode_Class.gDecodeJsonNil)(exportsIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(exportsIsSymbol)(arrayShape2)()())());
var buildQuery1 = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(idsIsSymbol)(hqtArray)(encodeJsonArray)()())(/* #__PURE__ */ rltvfConsOther(idsIsSymbol)())())(jsonQR1);
var buildMutation2 = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(form_idIsSymbol)(hqtArray)(encodeJsonArray)()())(/* #__PURE__ */ rltvfConsOther(form_idIsSymbol)())())(GraphQL_Query.unitQR);
var encodeJsonMaybe = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(encRNTY);
var student_idIsSymbol = {
    reflectSymbol: function () {
        return "student_id";
    }
};
var buildMutation3 = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ rltvCons2(/* #__PURE__ */ GraphQL_Type.hqtMaybe(rntyType))(encodeJsonMaybe)()())(student_idIsSymbol)(rntyType)(encRNTY)()())(semesterIsSymbol)(GraphQL_Type.hqtStr)(Data_Argonaut_Encode_Class.encodeJsonJString)()())(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ rltvfConsOther2(student_idIsSymbol)())(semesterIsSymbol)())())(jsonQR);
var gEncodeJsonCons1 = /* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var buildMutation4 = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons1(/* #__PURE__ */ GraphQL_Type.hqtArray(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "CreateFormInput";
    }
})))(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJString))(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonMaybe)(/* #__PURE__ */ gEncodeJsonCons1({
    reflectSymbol: function () {
        return "type_id";
    }
})())(teacher_idIsSymbol)())(student_idIsSymbol)())(semesterIsSymbol)())())))()())(rltvfConsOther1)())(jsonQR1);
var buildMutation5 = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons1(/* #__PURE__ */ GraphQL_Type.hqtArray(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "CopyFormInput";
    }
})))(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons1(student_idIsSymbol)())(form_idIsSymbol)())())))()())(rltvfConsOther1)())(/* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons10(idIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(formsIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons1(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())()));
var toggleDocumentLocks = function (inputs) {
    var process = function (v) {
        return v.forms;
    };
    return GraphQL_Query.nameQuery("ToggleDocumentLocks")(map(process)(buildMutation("updateForms")({
        input: map1(GraphQL_Type.namedType)(inputs)
    })));
};
var processExports = function (v) {
    return v.exports;
};
var processDocument = function (formId) {
    return function (mutations) {
        var $1506 = merge({
            formId: formId,
            mutations: mutations
        });
        var $1507 = rename(Type_Proxy["Proxy"].value)(Type_Proxy["Proxy"].value);
        var $1508 = rename1(Type_Proxy["Proxy"].value)(Type_Proxy["Proxy"].value);
        var $1509 = modify(Type_Proxy["Proxy"].value)(map1(API_Comments.processComment));
        return function ($1510) {
            return $1506($1507($1508($1509($1510))));
        };
    };
};
var updateDocument = function (doc) {
    return function (json) {
        return function (v) {
            return GraphQL_Query.nameQuery("UpdateDocument")(map(processDocument(doc.formId)(doc.mutations))(buildMutation1(doc.mutations.update)({
                id: doc.id,
                semester: v.semester,
                teacher_id: v.teacher,
                data: new GraphQL_Type.DyNamedType(doc.formName + "Input", json)
            })));
        };
    };
};
var fetchDocumentQuery = function (ft) {
    return function (id) {
        return GraphQL_Query.nameQuery("GetDocument")(map(processDocument(ft.id)(ft.mutations))(buildQuery("form")({
            id: id
        })));
    };
};
var exportDocuments = function (ids) {
    return GraphQL_Query.nameQuery("ExportDocuments")(map(processExports)(buildQuery1("forms")({
        ids: ids
    })));
};
var deleteDocuments = function (ids) {
    return GraphQL_Query.nameQuery("DeleteDocuments")(buildMutation2("deleteForms")({
        form_id: ids
    }));
};
var createDocument = function (ft) {
    return function (args) {
        return GraphQL_Query.nameQuery("CreateDocument")(map(processDocument(ft.id)(ft.mutations))(buildMutation3(ft.mutations.create)(args)));
    };
};
var createAndExport = function (forms) {
    return GraphQL_Query.nameQuery("CreateAndExportDocuments")(map(processExports)(buildMutation4("createForms")({
        input: map1(GraphQL_Type.namedType)(forms)
    })));
};
var copyDocuments = function (copies) {
    var process = function (r) {
        return map1(function (v) {
            return v.id;
        })(r.forms);
    };
    return GraphQL_Query.nameQuery("CopyDocuments")(map(process)(buildMutation5("copyForms")({
        input: map1(GraphQL_Type.namedType)(copies)
    })));
};
var applyLockPermission = function (v) {
    return function (record) {
        var $1501 = {};
        for (var $1502 in record) {
            if ({}.hasOwnProperty.call(record, $1502)) {
                $1501[$1502] = record[$1502];
            };
        };
        $1501.locked_at = v.locked_at;
        $1501.can = (function () {
            var $1498 = {};
            for (var $1499 in record.can) {
                if ({}.hasOwnProperty.call(record.can, $1499)) {
                    $1498[$1499] = record["can"][$1499];
                };
            };
            $1498.lock = v.can.lock;
            $1498.update = v.can.update;
            return $1498;
        })();
        return $1501;
    };
};
export {
    processDocument,
    fetchDocumentQuery,
    createDocument,
    updateDocument,
    copyDocuments,
    deleteDocuments,
    processExports,
    exportDocuments,
    createAndExport,
    applyLockPermission,
    toggleDocumentLocks
};
//# sourceMappingURL=index.js.map
